import React from 'react';
import {graphql, Link, StaticQuery} from 'gatsby';
import styled, {css} from 'styled-components';

import LogoImg from '../../assets/logos/MiurosLogo.svg';
import LinkedinIcon from '../../assets/icons/linkedin_icon_rounded.svg';
import TwitterIcon from '../../assets/icons/twitter_icon_rounded.svg';
import EmailIcon from '../../assets/icons/email.svg';
import ZendeskLogo from '../../assets/logos/Zendesk-Logo.png';
import TechstarsLogo from '../../assets/logos/Techstars-Logo.png';
import TheFamilyLogo from '../../assets/logos/TheFamily-Logo.png';
import BpiLogo from '../../assets/logos/Bpi-Logo.png';
import EULogo from '../../assets/logos/eu-logo.jpg';
import {getColors, maxMediaQueries} from '../utils/styling';
import {Col, Grid, Row} from 'react-styled-flexboxgrid';
import {H6Small, PSmall, PSmaller} from '../atoms/TextComponents';
import FlexWrapper from './shared/FlexWrapper';
import {IntegrationLabel} from './shared/integration-label';
import {ObfuscatedLink} from '../atoms/ObfuscatedLink';

// TODO optimize logo sizes
const FooterSection = styled.section`
  ${({theme}) => css`background-color: ${getColors(theme).gray800}`};

  > div {
    padding: 64px 0;
  }

  .logo {
    width: 92px;
    height: 32px;
  }

  ${maxMediaQueries.sm`
      > div {
        padding: 64px;
      }
      
      h6 {
       padding-top: 24px;
      }
   `};
`;

const FooterLinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;

  a {
    ${({theme}) => css`color: ${getColors(theme).gray100}`};
  }

  .integration-label {
    margin-left: 8px;
  }
`;

const CookieSettingsButton = styled.button`
  margin-top: 20px;
  outline: none;
  border-radius: 4px;
  border: 1px solid ${({theme}) => theme.colors.gray100};
  background-color: rgba(0, 0, 0, 0);
  color: ${({theme}) => theme.colors.gray100};
  font-size: 16px;
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 300ms;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const SocialMediaIcon = styled.img`
  width: 28px;
  height: 28px;
`;

const footerSocialMediaLogos = (
    <FlexWrapper row justify="flex-start">

      <div style={{marginRight: '8px'}}>
        <a style={{cursor: 'pointer'}} onClick={(e) => {
          e.preventDefault();
          window.open('mailto:info@miuros.com', '_self');
        }}><SocialMediaIcon src={EmailIcon} alt="Email"/></a>
      </div>
      <div>
        <a href="https://www.linkedin.com/company/miuros/">
          <SocialMediaIcon src={LinkedinIcon} alt="LinkedIn"/>
        </a>
      </div>

    </FlexWrapper>
);

const footerSupportedByLogos = (
    <FlexWrapper row justify="flex-start" wrapContent>
      <div style={{marginRight: '24px'}}>
        <img src={ZendeskLogo} width="60px" alt="Zendesk"/>
      </div>
      <div style={{marginRight: '24px'}}>
        <img src={TechstarsLogo} width="92px" alt="Techstars"/>
      </div>
      <div style={{marginRight: '38px'}}>
        <img src={TheFamilyLogo} width="34px" alt="The Family"/>
      </div>
      <div style={{marginRight: '38px'}}>
        <img src={BpiLogo} width="40px" alt="Bpi"/>
      </div>
      <div style={{marginRight: '38px'}}>
        <img src={EULogo} width="70px" alt="EU"/>
        <p style={{fontSize: '8px', color: '#ffffff'}}>EUROPEAN UNION</p>
      </div>
    </FlexWrapper>
);

const handleCookieSettingsClick = () => {
  if (window.cookiehub) {
    window.cookiehub.openSettings();
  }
};

export default (props) => (
    <StaticQuery
        query={graphql`
      query {
        allContentfulFooter {
          edges {
            node {
              footerFeatures
              useCases
              blog
              assist
              insights
              experience
              integrations
              companyName
              addressStreet1
              addressStreet2
              addressCountry
              about
              careers
              privacy
              supported
              copyright
            }
          }
        }
        allContentfulIntegration(sort: {fields: publicationDate, order: ASC}) {
            nodes {
                slug
                integrationName
                novelty
            }
        }
      }
  `}
        render={
          data => (
              <FooterSection>
                <Grid>
                  <Row>

                    <Col xs={12} sm={6}>
                      <div>
                        <img className="logo" src={LogoImg} alt="Miuros"/>
                      </div>
                      <div style={{margin: '12px 0'}}>
                        <PSmall color="gray100">
                          {data.allContentfulFooter.edges[0].node.companyName}
                          <br/>
                          {data.allContentfulFooter.edges[0].node.addressStreet1}
                          <br/>
                          {data.allContentfulFooter.edges[0].node.addressStreet2}
                          <br/>
                          {data.allContentfulFooter.edges[0].node.addressCountry}
                        </PSmall>
                      </div>
                      <div>
                        {footerSocialMediaLogos}
                      </div>
                      <div style={{marginTop: '24px'}}>
                        <PSmaller color="gray100" style={{marginBottom: '8px'}}>
                          {data.allContentfulFooter.edges[0].node.supported}
                        </PSmaller>
                        {footerSupportedByLogos}
                      </div>
                    </Col>

                    <Col xs={12} sm={6}>
                        <H6Small color="gray500" noSpacing>
                            About Miuros
                        </H6Small>
                      <Row>
                        <Col xs={12} sm={6}>
                        <FooterLinkWrapper>
                            <a href="https://www.dixa.com/miuros-by-dixa">Products</a>
                        </FooterLinkWrapper>
                          <FooterLinkWrapper>
                            <a href="https://www.dixa.com/pricing">Pricing</a>
                          </FooterLinkWrapper>
                          <FooterLinkWrapper>
                            <a href="https://www.dixa.com/about/">Who We Are</a>
                          </FooterLinkWrapper>
                          <FooterLinkWrapper>
                            <a href="https://www.welcometothejungle.com/fr/companies/miuros/jobs">
                              {data.allContentfulFooter.edges[0].node.careers}
                            </a>
                          </FooterLinkWrapper>
                          <FooterLinkWrapper>
                            <a href="https://www.dixa.com/customers/">
                              {data.allContentfulFooter.edges[0].node.useCases}
                            </a>
                          </FooterLinkWrapper>
                        </Col>
                          <Col xs={12} sm={6}>
                              <FooterLinkWrapper>
                                  <a href="https://www.dixa.com/blog">
                                      {data.allContentfulFooter.edges[0].node.blog}
                                  </a>
                              </FooterLinkWrapper>
                              <FooterLinkWrapper>
                                  <a href="https://www.dixa.com/legal/privacy/">
                                      {data.allContentfulFooter.edges[0].node.privacy}
                                  </a>
                              </FooterLinkWrapper>
                              <FooterLinkWrapper>
                                  <a href="https://www.notion.so/miuros/Miuros-Media-Kit-46704a49f11e4a85a606a53570a9e5c2"
                                     target="_blank">
                                      Media Kit
                                  </a>
                              </FooterLinkWrapper>
                              <CookieSettingsButton onClick={() => handleCookieSettingsClick()}>
                                  Cookie Settings
                              </CookieSettingsButton>
                          </Col>
                      </Row>
                    </Col>

                  </Row>
                </Grid>
              </FooterSection>
          )}
    />
)
